<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>
                        SMT. Sadabai Raisoni Memorial Maharashtra State Level Women's Badminton Tournament
                    </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-md-7">
                <p>Raisoni Foundation Presents Yonex-Sunrise Smt. Sadabai Raisoni Memorial Maharashtra State Women’s Badminton Tournament 2025</p>
                <p>The Raisoni Foundation Presents Yonex-Sunrise Smt. Sadabai Raisoni Memorial Maharashtra State Women’s Badminton Tournament 2025 was successfully held from 7th March to 9th March 2025 at the Subhedar Badminton Hall, Nagpur. The event saw a total of 232 entries across 13 events, showcasing remarkable performances and fierce competition. The total prize pool for the tournament was ₹5,40,000.</p>
                <p>
                    <strong>Here are the results from the tournament:</strong>
                </p>
                <h6 class="mt-4">Women’s Doubles 45:</h6>
                <ul class="list-style list-style1  mb-3 ">
                    <li>1. Anjali Kale + Madhavi Kasikar Hedau</li>
                    <li>2. Anjali Lotke + Purnima Deshmukh</li>
                    <li>3. Sheetal Arya + Swati Paturkar</li>
                    <li>3.  Bhagyashree Khante + Rajeshree Hatwar</li>
                </ul>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/upcoming-sports/mh-womens-badminton-tournament.webp" alt="GHRSCF">
                </div>
            </div>
        </div>
        <hr>
        <div class="row align-items-center">
            <div class="col-md-4">
                <h6>Women’s Singles 45:</h6>
                <ul class="list-style list-style1">
                    <li> 1. Madhavi Kasikar Hedau</li>
                    <li> 2. Anjali Lotke</li>
                    <li>3. Swati Paraskar</li>
                    <li>3. Anjali Kale</li>
                </ul>
            </div>
            <div class="col-md-4">
                <h6>Women’s Doubles 35:</h6>
                <ul class="list-style list-style1">
                    <li>1. Manisha Bhawatkar + Manjiri Dhok</li>
                    <li>2. Anjali Kale + Priyanka Khedkar</li>
                    <li>3. Krishna Agrawal + Madhu Adwani</li>
                    <li>3.Anjali Lotke + Purnima Deshmukh</li>
                </ul>
            </div>
            <div class="col-md-4">
                <h6>Women’s Singles 35:</h6>
                <ul class="list-style list-style1">
                    <li>1. Manjiri Dhok</li>
                    <li>2.Prachi Sakalle</li>
                    <li>3.Triveni Mudliar</li>
                    <li>3.Priyanka Khedkar</li>
                </ul>
            </div>
            <hr>
            <div class="col-md-4">
                <h6>Girls’ Singles Under 17:</h6>
                <ul class="list-style list-style1">
                    <li>1. Vidhi Saini,</li>
                    <li>2.Vaishnavi Manglekar,</li>
                    <li>3. Sanvi Ghate</li>
                    <li>3.Yukti Shende</li>
                </ul>
            </div>
            <div class="col-md-4">
                <h6>Girls’ Singles Under 15:</h6>
                <ul class="list-style list-style1">
                    <li>1.Vaishnavi Manglekar</li>
                    <li>2.Shreeja Wankhede</li>
                    <li>3.Vidhi Saini</li>
                    <li>3.Sanvi Ghate</li>
                </ul>
            </div>
            <div class="col-md-4">
                <h6> Girls’ Doubles Under 13:</h6>
                <ul class="list-style list-style1">
                    <li>1.Aaradhya Sahare + Anudhya Satpute</li>
                    <li>2.Aradhya Gupta + Gautami Chaudhari</li>
                    <li>3.Ira Rokade + Sharvani Bhoot</li>
                    <li>3.Ishita Patil + Kshitija Patil</li>
                </ul>
            </div>
            <hr>
            <div class="col-md-4">
                <h6> Girls’ Singles Under 13:</h6>
                <ul class="list-style list-style1">
                    <li>1.Anudhya Satpute</li>
                    <li>2.Spruha Joshi</li>
                    <li>3.Dhriti Mehta</li>
                    <li>3.Shashwati Deshmukh</li>
                </ul>
            </div>
            <div class="col-md-4">
                <h6> Girls’ Singles Under 11:</h6>
                <ul class="list-style list-style1">
                    <li>1.Ira Rokade</li>
                    <li>2.Aanya Malhotra</li>
                    <li>3.Akshita Dorshatwar</li>
                    <li>3.Kshitija Yaul</li>
                </ul>
            </div>
            <div class="col-md-4">
                <h6> Girls’ Singles Under 9:</h6>
                <ul class="list-style list-style1">
                    <li>1.Ananya Manglekar</li>
                    <li>2.Neetya Sahare</li>
                    <li>3.Sanvi Khot</li>
                    <li>3.Tithi Verma</li>
                </ul>
            </div>
            <hr>
            <div class="col-md-4">
                <h6> Women’s Doubles:</h6>
                <ul class="list-style list-style1">
                    <li>1.Krisha Soni + Nishika Gokhe</li>
                    <li>2.Nehal Gosavi + Nikkita Joseph</li>
                    <li>3.Akshaya Warang + Sonali Mirkhelkar</li>
                    <li>3.Ananya Durugkar + Hrissha Dubey</li>
                </ul>
            </div>
            <div class="col-md-4">
                <h6> Women’s Singles (WS):</h6>
                <ul class="list-style list-style1">
                    <li>1.Nishika Gokhe</li>
                    <li>2.Kripi Sajwan</li>
                    <li>3.Shruti Shankargouda</li>
                    <li>3.Nehal Gosavi</li>
                </ul>
            </div>
        </div>
        <hr>
        <h4> Special Recognitions:</h4>
        <div class="row row-cols-md-2 row-cols-1 justify-content-start">
            <div class="col-md-4 col">
                <h6> Chief Guests:</h6>
                <ul class="list-style ">
                    <li>Smt. Kanchantai Gadkari</li>
                    <li>Hon. Justice M. S. Kawalkar</li>
                    <li>Guest of Honour:</li>
                </ul>
            </div>
            <div class="col-md-5 col">
                <h6>Guest of Honour:</h6>
                <ul class="list-style list-count">
                    <li>Shri Sunil Raisoni</li>
                    <li>Smt. Shobha Raisoni</li>
                    <li>Mrs. Trupti Karangutkar</li>
                    <li>Dr. Vishakha Joshi</li>
                    <li>Dr. Amina Vali</li>
                    <li>Dr. Mrinalini Naik</li>
                    <li>Mrs. Neelu Garg</li>
                    <li>Dr. Sameer Paltewar</li>
                </ul>
            </div>
        </div>
        <h6>Asia Book of Records Achievement:</h6>
        <ul class="list-style">
            <li> Dr. Sunita Dhote was felicitated for her record-breaking achievement in the Longest Cycle Expedition.</li>
        </ul>
        <h6> Outstanding International Badminton Performance:</h6>
        <ul class="list-style">
            <li>Ritika Thaker and Malvika Bansod were honored for their exceptional achievements at the international level.</li>
        </ul>
        <hr>
        <p>The total prize pool of ₹5,40,000 made this competition even more exciting!</p>
        <p>We would like to extend our congratulations to all the winners and participants who made this event a grand success! Stay tuned for more updates on future tournaments and events.</p>
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-1">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="https://drive.google.com/drive/folders/1ZJzXoB_nCqNL9EbX3fTmwKKt8F3iNMM1" target="_blank" class="btn button--effect-1">
                            <span>
                                View More
                            </span>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-1.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-1.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-1.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-2.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-2.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-2.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-3.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-3.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-3.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-4.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-4.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-4.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-5.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-5.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-5.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-6.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-6.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-6.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-7.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-7.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-7.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-8.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-8.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-8.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="border-line-sm"></div>
            <div class="col">
                <div class="row ">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-md-4 row-cols-2">
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-4.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-4.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-4.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-5.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-5.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-5.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-1.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-1.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-1.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-2.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-2.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-2.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-3.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-3.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-3.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-6.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-6.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-6.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-7.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-7.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-7.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-8.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-8.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-8.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-9.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-9.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-9.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-10.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-10.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-10.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                        <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-11.webp" data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-11.webp">
                            <a href="Javascript:void(0);">
                                <img
                                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sadabai-womens-badminton-tournament-media-11.webp"
                                    alt="GHRSCF"
                                    title="GHRSCF"
                                    class="img-fluid"
                                >
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png">
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
